import { useUser } from '@/biz/user.mjs';
import { isAdmins } from "@/script/admin.js";

const collectPermissions = (...dicts) => {
    const permissions = {};

    for (const id2codes of dicts) {
        for (const [id, codes] of Object.entries(id2codes ?? {})) {
            if (permissions[id]) {
                permissions[id].push(...codes);
            }
            else {
                permissions[id] = [...codes];
            }
        }
    }

    return permissions;
}

const containsAll = (arr1, arr2) => arr2.every((val) => arr1.includes(val));

const usePermission = (permissions, projects) => {
    const user = useUser();

    if (!user) {
        return false;
    }

    if (isAdmins(user)) {
        return true;
    }

    const { projectFaMap, projectMenuMap } = user;
    const projectPermission = collectPermissions(projectMenuMap, projectFaMap);

    if (projects.length > 0) {
        let voteCount = 0;
        for (const project of projects) {
            const pers = projectPermission[project] ?? [];
            if (containsAll(pers, permissions)) {
                voteCount++;
            }
        }

        return voteCount == projects.length;
    }

    return false;
}

export default usePermission;